import { Box } from "@mui/material";
import { MenuItems } from "./Header";
import { HashNavLink } from "../../custom/HashNav";
import LanguageSwitch from "../LanguageSwitch";
import ReactGA from "react-ga4";
import React, { useState, useRef, useEffect } from "react";

export type SubMenuItem = {
  ID: number;
  title: string;
  url: string;
};

type MenuProps = {
  menuItems: MenuItems;
  submenu: SubMenuItem[];
  onAssistantClick?: () => void;
};

const Menu: React.FC<MenuProps> = ({ menuItems, submenu, onAssistantClick }) => {
  const [productsOpen, setProductsOpen] = useState(false);
  const productsRef = useRef<HTMLDivElement>(null);

  const toggleProducts = () => {
    setProductsOpen((prev) => !prev);
  };

  const clickHandler = (url: string) => {
    ReactGA.event({
      category: "Button",
      action: url,
      label: "Bookmark",
    });

    if (url === "/assistant" && onAssistantClick) {
      setProductsOpen(false);
      onAssistantClick();
      return;
    }

    if (url.startsWith("http")) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (productsRef.current && !productsRef.current.contains(event.target as Node)) {
        setProductsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuList = menuItems.map(({ id, title, url }, i, arr) => {
    if (title === "languageSwitch") {
      return (
        <Box key={id} sx={{ display: "inline-block" }}>
          <LanguageSwitch sx={{ ...(arr.length - 1 !== i && { mr: 9 }) }} underline="none" />
        </Box>
      );
    }

    return (
      <Box sx={{ display: "inline-block" }} key={id}>
        <HashNavLink
          onClick={() => clickHandler(url)}
          to={url}
          underline="none"
          sx={{ ...(arr.length - 1 !== i && { mr: 9 }) }}
        >
          {title}
        </HashNavLink>
      </Box>
    );
  });

  return <Box sx={{ display: { xs: "none", md: "block" } }}>{menuList}</Box>;
};

export default Menu;
